module.exports = __webpack_public_path__ + "static/media/Galdeano-Regular.ca125565.ttf";